import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
} from "reactstrap";
import { Link } from "react-router-dom";

import classNames from "classnames";

// Import Charts
import StackedColumnChart from "./StackedColumnChart";

// Import action
import { getChartsData as onGetChartsData } from "../../store/actions";

// Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// i18n
import { withTranslation } from "react-i18next";

// redux
import { useSelector, useDispatch } from "react-redux";
import BotpressChat from "./BotpressChat";

const Dashboard = (props) => {

  const [marginTop, setMarginTop] = useState("20px");
  // Meta title
  document.title = "Dashboard | Ai in realstate";
  useEffect(() => {
    const updateMarginTop = () => {
      const isMobile = window.innerWidth <= 768; // Define mobile breakpoint
      setMarginTop(isMobile ? "420px" : "550px"); // Adjust margins for mobile and desktop
    };

    updateMarginTop(); // Set initial margin on component mount
    window.addEventListener("resize", updateMarginTop); // Update margin on window resize

    return () => {
      window.removeEventListener("resize", updateMarginTop); // Cleanup event listener
    };
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Dummy Content for Testing Scroll */}
          <Row className="content-wrapper">
            {/* <Row>
              {Array.from({ length: 2 }, (_, index) => (
                <Col lg="12" key={index} className="mb-4">
                  <Card>
                    <CardBody>
                      <h5>AI IN REALESTATE {index + 1}</h5>
                      <p>
                        "Need assistance with your real estate journey? From house rentals to property sales,
                        I provide expert guidance every step of the way."
                      </p>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row> */}
            <Row>
              {/* Botpress Chat */}
              <BotpressChat />
            </Row>
            {/* <Row>
              {Array.from({ length: 2 }, (_, index) => (
                <Col lg="12" key={index} className="mb-4">
                  <Card>
                    <CardBody>
                      <h5>Section {index + 1}</h5>
                      <p>
                        "Need assistance with your real estate journey? From house rentals to property sales,
                        I provide expert guidance every step of the way."
                        I provide expert guidance every step of the way
                      </p>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row> */}
            <hr />
            <Row>
              {/* YouTube Video */}
              <Col lg="12" className="mb-4">
                <div
                  style={{
                    position: "relative",
                    paddingBottom: "56.25%",
                    height: 0,
                    overflow: "hidden",
                    maxWidth: "100%",
                    marginTop: marginTop, // Apply dynamic margin
                    border: "1px solid white", // Add a thin white border
                    borderRadius: "5px", // Optional: Add rounded corners
                    boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
                  }}
                >
                  <iframe
                    src="https://www.youtube.com/embed/S0xyHHe80CA?si=6x8skXR7bdy1UYSH"
                    title="YouTube video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
                  ></iframe>
                </div>
              </Col>
            </Row>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Dashboard);
